import Slider from "../../components/slider";
import Employer from "../../components/employer";
import Sections from "./sections";
import RegisterTwo from "../../components/registertwo";
import SocialFloatingMenu from "../../components/SocialFloatingMenu"; // Importación del menú flotante

const Home = () => {
  return (
    <>
      <Slider />
      <Sections />
      <RegisterTwo />
      <Employer />
      <SocialFloatingMenu />
    </>
  );
};

export default Home;




